export const MODELS = ["gpt-4o", "gpt-4o-mini"] as const;

export type Model = (typeof MODELS)[number];
export function isModel(model: string): model is Model {
  return MODELS.includes(model as Model);
}
